import BaseBoosterBehavior, { IBaseBoosterBehaviorPlayMeta } from './BaseBoosterBehavior';
import { PreBoosterType } from '../BoosterType';
import { IGameState } from '../../Game/IGameState';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { TransactionType } from '../../../Utility/Tracking/DataSet/Transaction';
import CardStateHelper from '../CardStateHelper';
import { SCORE_VALUE_CARD } from '../../../Constants/Score';
import { ICardsState, ICardStateData } from '../ICardState';
import { CardTask } from '../CardTasks';
import { removeThreePreBoosterFilterCb, REMOVE_THREE_CARDS_AMOUNT } from './RemoveThreePreBoosterHelpers';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { report } from '../../../report';

export default class RemoveThreePreBoosterBehavior extends BaseBoosterBehavior {
    public removeOneCard(cardsState: ICardsState, cardID: string): ICardsState {        
        cardsState = CardStateHelper.increaseStreak(cardsState, SCORE_VALUE_CARD, cardID);
        cardsState = CardStateHelper.addTurnScore(cardsState, SCORE_VALUE_CARD);
        cardsState = CardStateHelper.setCardDiscarded(cardsState, cardID);
        cardsState = CardStateHelper.updateCards(cardsState);

        return cardsState;
    }

    public play(state: IGameState, meta?: IBaseBoosterBehaviorPlayMeta): IGameState {
        let cardsToAnimate: string[] = []
        let cardsState = state.levelState.cardsState;
        for (let i = 0; i < REMOVE_THREE_CARDS_AMOUNT; i++) {
            let targetData = this.getNextMatchData(cardsState);

            if (!targetData) {
                cardsState = queueAnimationTaskIfNeeded(cardsState);
                cardsState = CardStateHelper.checkCardsObscured(cardsState);
                targetData = this.getNextMatchData(cardsState);
                if (!targetData) {
                    report("Cannot find all matches for RemoveThreePreBooster", {
                        once: true,
                        sampleRate: 0.1,
                        tags: {
                            levelNumber: state.levelState.levelNumber,
                        },
                        state
                    })
                    break;
                }
            }
            const connectedModifiers = CardStateHelper.getModifiersOfType(cardsState, targetData.id, CardModifierType.connected);
            connectedModifiers.forEach(modifier => {
                const cardIDToAdd = modifier.properties.cardID;
                if (cardIDToAdd) {
                    cardsToAnimate.push(cardIDToAdd);
                    cardsState = this.removeOneCard(cardsState, cardIDToAdd);
                }
            });

            cardsToAnimate.push(targetData.id);
            cardsState = this.removeOneCard(cardsState, targetData.id);
        }

        cardsState = queueAnimationTaskIfNeeded(cardsState);

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState: cardsState,
            },
        };

        state = this.consumeItemOrCoins(state);

        return state;

        function queueAnimationTaskIfNeeded(cardsState: ICardsState): ICardsState {
            if (cardsToAnimate.length > 0) {
                cardsState = CardStateHelper.setStateTaskData(cardsState, {
                    task: CardTask.REMOVE_THREE_PRE_BOOSTER,
                    cards: cardsToAnimate,
                    cardsData: cardsToAnimate.map((id) => { return cardsState.cards[id] })
                });
                cardsToAnimate = [];
            }
            return cardsState;
                
        }
    }

    private getPossibleMatchData(cardsState: ICardsState): ICardStateData[] {
        return cardsState.inPlay
        .map((cardID) => cardsState.cards[cardID])
        .filter(card => removeThreePreBoosterFilterCb(cardsState, card.id))
    }

    
    private getNextMatchData(cardsState: ICardsState): ICardStateData {
        return this.getPossibleMatchData(cardsState)
            .sort((a, b) => a.depth - b.depth || Math.random() - 0.5)
            .pop();
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices[PreBoosterType.REMOVE_THREE];
    }

    public getInventoryItem(state: IGameState): number {
        return state.playerState.inventory[PreBoosterType.REMOVE_THREE];
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        track('transactionType', TransactionType.INVENTORY);
        return this.decrementInventoryItem(state, PreBoosterType.REMOVE_THREE);
    }

    protected spendCoins(state: IGameState): IGameState {
        super.trackCoinsSpent(state, 'tRemoveCardsBoostersCoins');
        state = super.spendCoins(state);
        return this.incrementBoosterUse(state, PreBoosterType.REMOVE_THREE);
    }

    protected consumeItemOrCoins(state: IGameState): IGameState {
        track('tRemoveCardsBoostersUsed', 1, TrackMethod.ADD);
        track('mRemoveCardsBoostersUsed', 1, TrackMethod.ADD);

        return super.consumeItemOrCoins(state);
    }
}
